import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { BaseRouteParams, WithNavigationProps, withNavigation } from 'hocs'
import { getAllSelectedOrderItemsUuids, getSelectedOrdersList } from 'orders/orders/redux'
import OrderTicketsActions from '../../commons/orderTicketsActions'
import OrdersFilter from 'orders/orders/filters/dynamicFilters'
import OrdersSearchBar from 'orders/orders/filters/ordersSearchBar'
import OrdersDateFilter from 'orders/orders/filters/ordersDateFilter'
import SearchTermBadge from 'orders/orders/filters/searchTermBadge'
import OrdersExportButton from './ordersExportButton'
import ColumnsConfigurator from './utilitiesHeader/columnsConfigurator'
import { SearchScopeBadge, VIA_SEARCH_PARAM } from 'uiComponents/searchScopeBadge'
import 'uiComponents/table/tableToolbar.scss'
import { ReplaceMessagesFunc } from 'messagesContext'

interface HeaderProps {
    hideMessage: (id: string) => void
    replaceMessages: ReplaceMessagesFunc
}

const Header: FC<WithNavigationProps<BaseRouteParams> & HeaderProps> = ({
    match,
    navigation,
    hideMessage,
    replaceMessages,
}) => {
    const { accountSlug } = match.params
    const location = useLocation()
    const areItemsSelected = useSelector(getAllSelectedOrderItemsUuids).length > 0
    const areOrdersSelected = useSelector(getSelectedOrdersList).length > 0
    const hasSearch = !!navigation.query().search
    const hasSearchScope = !!new URLSearchParams(location.search).get(VIA_SEARCH_PARAM)

    return (
        <div className="table-toolbar">
            <div className="header-row">
                {areItemsSelected || areOrdersSelected ? (
                    <OrderTicketsActions hideMessage={hideMessage} replaceMessages={replaceMessages} />
                ) : (
                    <div className="header-group header-group--spaced">
                        <OrdersSearchBar />
                        <OrdersDateFilter />
                        <div className="header-group">
                            <OrdersFilter page="orders" accountSlug={accountSlug} iconOnly />
                            <ColumnsConfigurator accountSlug={accountSlug} iconOnly />
                        </div>
                        <OrdersExportButton accountSlug={accountSlug} />
                    </div>
                )}
            </div>
            {(hasSearch || hasSearchScope) && (
                <div className="header-row header-row--scope">
                    <SearchTermBadge />
                    <SearchScopeBadge />
                </div>
            )}
        </div>
    )
}

export default withNavigation(Header)
